import Vue from 'vue'
import _ from 'lodash'
import {StylesParser} from "../StylesParser"
import {ConstantsParser} from "../ConstantsParser"
import ArrayManipulation from '../mixins/ArrayManipulation'
export default Vue.extend({
  props: {
    parentModule: {
      type: String,
      required: false
    },
    layoutComponent: {
      type: Boolean,
      required: false,
      default: false
    },
    innerComponent: {
      type: Boolean,
      required: false,
      default: false
    },
    pageComponent: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  mixins: [ArrayManipulation],
  data() {
    return {
      childHover: false,
      hover: false
    }
  },
  watch: {
    hover(value) {
      return value ? this.$emit('mouseover') : this.$emit('mouseleave')
    }
  },
  computed: {
    name() {
      return this.$store.getters[`${this.module}/name`](this.element, this.parentModule)
    },
    content() {
      return this.$store.getters[`${this.module}/content`](this.element, this.parentModule)
    },
    properties() {
      return this.$store.getters[`${this.module}/properties`](this.element, this.parentModule)
    },
    family() {
      return 'components'
    },
    previewMode() {
      return this.$store.state.previewMode
    },
    device() {
      return this.$store.getters['pageModule/device']
    },
    module() {
      if (this.innerComponent) {
        return 'componentComponentModule'
      }

      if (this.layoutComponent) {
        return 'layoutComponentModule'
      }

      return 'componentModule'
    },
    parent() {
      return this.$parent.$parent.$parent
    },
    id() {
      return this.$vnode.key
    },
    element() {
      let element = {
        pageComponent: this.pageComponentIndex,
        section: this.sectionIndex,
        row: this.rowIndex,
        column: this.columnIndex,
        component: this.componentIndex,
        componentSection: this.componentSectionIndex,
        componentRow: this.componentRowIndex,
        componentColumn: this.componentColumnIndex,
        componentComponent: this.componentComponentIndex,
      }

      if (this.parentModule === 'layoutPageComponentModule') {
        element = {
          layoutPageComponent: this.pageComponentIndex,
          section: this.sectionIndex,
          row: this.rowIndex,
          column: this.columnIndex,
          component: this.componentIndex,
          componentSection: this.componentSectionIndex,
          componentRow: this.componentRowIndex,
          componentColumn: this.componentColumnIndex,
          componentComponent: this.componentComponentIndex,
        }
      }

      let newElement = Object.keys(element)
        .filter(key => element[key] != null)
        .reduce((obj, key) => {
          obj[key] = element[key]
          return obj
        }, new Object)

      return newElement
    },
      menuOptions() {
        return this.$store.getters[`${this.module}/properties`](this.element, this.parentModule).menu
      },
      editorClasses() {
        if (this.$root.previewMode) {
          return new Array
        }
        let classes = ['wf-relative', 'wf-border', 'wf-border-transparent']
        if (this.hover && ! this.childHover) {
          classes.push('border-blue-300')
        }
        return classes
      },
      pageComponentIndex() {
        return this.parent.pageComponentIndex
      },
      sectionIndex() {
        return this.parent.sectionIndex
      },
      rowIndex() {
        return this.parent.rowIndex
      },
      columnIndex() {
        return this.parent.columnIndex
      },
      componentIndex() {
        if (this.innerComponent) {
          return this.parent.componentIndex
        }
        return this.$store.getters[`${this.module}/index`]({
          section: this.sectionIndex,
          row: this.rowIndex,
          column: this.columnIndex
        }, this.id, this.parentModule)
      },
      componentSectionIndex() {
        return this.parent.componentSectionIndex
      },
      componentRowIndex() {
        return this.parent.componentRowIndex
      },
      componentColumnIndex() {
        return this.parent.componentColumnIndex
      },
      componentComponentIndex() {
        if (! this.innerComponent) {
          return null
        }
        if (this.parentModule === 'layoutPageComponentModule') {
          return this.$store.getters[`${this.module}/index`]({
            layoutPageComponent: this.pageComponentIndex,
            section: this.sectionIndex,
            row: this.rowIndex,
            column: this.columnIndex,
            component: this.componentIndex,
            componentSection: this.componentSectionIndex,
            componentRow: this.componentRowIndex,
            componentColumn: this.componentColumnIndex,
          }, this.id, this.parentModule)
        }
        return this.$store.getters[`${this.module}/index`]({
          pageComponent: this.pageComponentIndex,
          section: this.sectionIndex,
          row: this.rowIndex,
          column: this.columnIndex,
          component: this.componentIndex,
          componentSection: this.componentSectionIndex,
          componentRow: this.componentRowIndex,
          componentColumn: this.componentColumnIndex,
        }, this.id, this.parentModule)
      },
  },
  methods: {
    updateContentProperty: _.debounce(function (property, value) {
      let object = {}
      this.$set(object, property, value)
      this.addToObject(this.module, object, 'content', null, {}, true, this.parentModule)
    }, 1000),
    classes(classes) {
      return this.$store.getters[`${this.module}/classes`](this.element, classes, this.parentModule)
    },
    elementClasses(classes, otherClasses = []) {
      classes = (new ConstantsParser(classes, this.device)).parse()
      let constantClasses = (new ConstantsParser(this.classes('constantClasses'), this.device)).parse()
      return [...classes, ...otherClasses, ...constantClasses]
    },
    styles(styles) {
      return this.$store.getters[`${this.module}/styles`](this.element, styles, this.parentModule)
    },
    elementStyles(styles) {
      return (new StylesParser(styles, this.device)).parse()
    },
  }
})